import BaseModel from "nexia_mobile/models/base_model";
import VideoFeed from "nexia_mobile/models/mixins/video_feed";
import Editable from "nexia_mobile/models/mixins/editable";

class RecordedVideo extends BaseModel {
  static isEphemeral = true;

  getResolution() {
    return this.get("resolution");
  }

  onParse(rawAttrs) {
    let attrs = super.onParse(rawAttrs);

    return {
      id: attrs.id,
      name: attrs.name,
      size: attrs.size,
      protected:
        attrs.write_protected == null ? attrs.protected : attrs.write_protected,
      thumbnail: attrs.thumbnail,
      mediaType: attrs.media_type == null ? attrs.mediaType : attrs.media_type,
      recordedAt:
        attrs.created_at == null ? attrs.recordedAt : attrs.created_at,
      trigger: attrs.trigger,
      quality: attrs.quality,
      resolution: attrs.resolution,
      aspectRatio:
        attrs.aspect_ratio == null ? attrs.aspectRatio : attrs.aspect_ratio,
    };
  }
}

_.extend(RecordedVideo.prototype, VideoFeed);
_.extend(RecordedVideo.prototype, Editable);
export default RecordedVideo;



// WEBPACK FOOTER //
// ./src/models/recorded_video.js